import { useQuery } from "@tanstack/react-query";
import { uniq } from "lodash";

import { axiosClient } from "../../utils/axiosClient";
import { RadioBigField } from "../../Shared/Fields/RadioBigField";
import { useSyncUrlParam } from "./useSyncUrlParam";
import {trackConversion} from "../../utils/analytics";

// TODO: useProductsQuery() hook here
export function ModelGroupSelector({ values, form }) {
    const queryParameters = {
        filter: {
            belongs_to_sales_productcategory: true,
            type: "unit",
            ...(values.productcategory !== "all" && {
                "productcategory.id": values.productcategory,
            }),
        },
    };
    const { data: products, isLoading: isProductsLoading } = useQuery({
        queryKey: ["productModels", queryParameters],
        queryFn: () =>
            axiosClient
                .get(route("products.index", queryParameters))
                .then((response) => response.data),
        enabled: !!values?.productcategory,
    });
    useSyncUrlParam(
        "product_number",
        (value) => {
            const product = products.find(
                (product) => product.number === value
            );

            if (product?.model_group) {
                form.change("model_group", product?.model_group);
                trackConversion({
                    action: "ShopModelGroup:"+product?.model_group,
                });
            }
        },
        {
            enabled: !isProductsLoading && !!products,
        }
    );

    if (isProductsLoading || !products) {
        return null;
    }

    const uniqueModelGroups = uniq(
        products?.map((product) => product.model_group)?.filter(Boolean) ?? []
    );

    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {uniqueModelGroups.map((modelGroup) => (
                    <RadioBigField
                        name="model_group"
                        key={modelGroup}
                        value={modelGroup}
                        onChange={() => {
                            trackConversion({
                                action: "ShopModelGroup:"+modelGroup,
                            });
                            form.change("variant", null);
                        }}
                    >
                        {modelGroup}
                    </RadioBigField>
                ))}
            </div>
        </div>
    );
}
